import PropTypes from 'prop-types'

export const ecobioTaxonTraitShape = PropTypes.shape({
    traitCode: PropTypes.number,
    modalityCode: PropTypes.number,
    taxonCode: PropTypes.string,
})